import 'isomorphic-fetch'

import { alertEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'

import {
  ADD_NEW_ALERT,
  FETCH_ALERTS,
  REMOVE_ALERT_BY_ID,
  FETCH_ALL_ALERTS,
  GLOBAL_ALERT_UPDATE_STATUS,
  FETCH_ALERT_TO_EDIT
} from '../actionTypes'

export const fetchAlertsList = params => async dispatch => {
  const { method, url } = alertEndpoint.list
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  const { alerts } = apiResponse
  dispatch({
    type: FETCH_ALERTS,
    payload: {
      alerts
    }
  })
}

export const fetchAllAlerts = () => async dispatch => {
  const { method, url } = alertEndpoint.init
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  const { allAlerts = [], allVenues = [] } = apiResponse
  dispatch({
    type: FETCH_ALL_ALERTS,
    payload: {
      allAlerts,
      allVenues
    }
  })
}
export const removeAlertById = (alertObjectId, accessToken) => async dispatch => {
  const { method, url } = alertEndpoint.delete(alertObjectId)
  const idToken = getIdToken()

  if (!idToken) {
    const errorResponse = {
      message: 'Authentication token is missing. Please log in again.',
      success: false
    }
    dispatch({
      type: REMOVE_ALERT_BY_ID,
      payload: errorResponse
    })
    return
  }

  const apiResponse = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${idToken}`,
      AccessToken: accessToken
    }
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => ({
      message: error.message,
      success: false
    }))
  const { deletedAlert } = apiResponse

  dispatch({
    type: REMOVE_ALERT_BY_ID,
    payload: {
      deleteMessage: deletedAlert?.acknowledged ? 'Alert deleted successfully' : 'Error while deleting alert',
      deleteStatus: deletedAlert?.acknowledged,
      deletedAlert
    }
  })
}

export const fetchAlertById = alertObjectId => async dispatch => {
  try {
    const { method, url } = alertEndpoint.edit(alertObjectId)
    const idToken = getIdToken()
    const apiResponse = await fetch(url, {
      headers: {
        Authorization: `Bearer ${idToken}`
      },
      method: method
    })
      .then(async response => await getApiResponseInJSON(response))
      .catch(error => console.error(error))
    dispatch({
      type: FETCH_ALERT_TO_EDIT,
      payload: {
        ...apiResponse
      }
    })
  } catch (error) {
    console.log(error)
  }
}

export const updateAlert = (alertObjectId, alert, accessToken) => async dispatch => {
  try {
    const { method, url } = alertEndpoint.update(alertObjectId)
    const idToken = getIdToken()
    await fetch(url, {
      body: JSON.stringify(alert),
      headers: {
        Authorization: `Bearer ${idToken}`,
        AccessToken: accessToken
      },
      method: method
    })
      .then(async response => await getApiResponseInJSON(response))
      .then(response => {
        const { message, success } = response
        dispatch({
          type: GLOBAL_ALERT_UPDATE_STATUS,
          payload: { message, success }
        })
      })
      .catch((error) => {
        console.log(error)
      })
  } catch (error) {
    console.log(error)
  }
}

export const resetUpdateAlertStatus = () => async dispatch => {
  dispatch({
    type: GLOBAL_ALERT_UPDATE_STATUS,
    payload: {
      message: '',
      success: false
    }
  })
}

export const addAlert = (alert, accessToken) => async dispatch => {
  try {
    const { method, url } = alertEndpoint.add
    const idToken = getIdToken()
    await fetch(url, {
      body: JSON.stringify({ alert }),
      headers: {
        Authorization: `Bearer ${idToken}`,
        AccessToken: accessToken
      },
      method
    })
      .then(async response => await getApiResponseInJSON(response))
      .then(response => {
        const { addedAlert: { _id: newAlertId }, message, success } = response
        dispatch({
          type: ADD_NEW_ALERT,
          payload: { newAlertId, message, success }
        })
      })
      .catch((error) => {
        console.log(error)
      })
  } catch (error) {
    console.log(error)
  }
}

export const resetAlertsActionStatus = () => async dispatch => {
  dispatch({
    type: ADD_NEW_ALERT,
    payload: {
      error: false,
      message: '',
      success: false
    }
  })
}
